module.exports = __webpack_public_path__ + "static/media/expert-chat-welcome-team.d7fe936c.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/TCH-WEB/expert-chat-welcome-team.jpg
// module id = 1289
// module chunks = 0